<!--Header responsible for arrows-->
<app-generic-header
  [goBack]="saveChangesButton ? saveButton.bind(this) : exitButton.bind(this)"
  [variant]="
  firstSetup
    ? 'empty'
    : (saveChangesButton ? 'save' : 'back')
">
</app-generic-header>

<ion-content class="ion-padding">

  <div class="centralized">
    
    <div class="page-image">
      <ion-icon src="/assets/imgs/custom-svg/padronized-sizes/height.svg"></ion-icon>
    </div>

    <div class="page-name">
      {{'whatIsYourHeight' | translate}}
    </div>

    <div class="heightMeasure">
      <span>{{setHeightScale()}}</span>
    </div>

        <ion-range  [(ngModel)]="heightValueCm" pin="true" min="140" max="220" step="1" (ionChange)="setHeightScale()">
          <ion-label style="font-size: 14px;" slot="start">1.4m</ion-label>
          <ion-label style="font-size: 14px;" slot="end">2.2m</ion-label>
        </ion-range>

    <!-- eslint-disable-next-line @angular-eslint/template/eqeqeq -->
    <div class="clear-height" *ngIf="userData?.height != null">
      <ion-button fill="outline" mode="md" class="back-button" size="small" shape="round" (click)="clearHeight()">{{ 'clearHeight' | translate }}</ion-button>
    </div>

    <div class="next-buttons">
      <ion-button fill="outline" mode= "md" class="back-button" (click)="backButton()" size="small" value="back"  shape="round">{{ 'backSurvey' | translate }}</ion-button>

      <ion-button color="secondary" mode= "md" (click)="nextButton()" size="small" value="next" shape="round">{{ 'nextSurvey' | translate }}</ion-button>
    </div>

    </div>
  
  </ion-content>